export const draftKeys = {
  all: ['draft'] as const,
  detail: (documentSuperId: number | string) => ['draft', String(documentSuperId)],
};
